// src/colors.ts
const colors = {
  colorPrimary: "#00266c",
  colorPrimaryWillineOrange: "#ff6347",
  colorPrimaryBg: "#d9e3e9",
  colorSecondary: "#6C757D",
  colorBorderGray: "#CCC",
  colorDanger: "#DC3545",
  colorWarning: "#FFC107",
  colorInfo: "#17A2B8",
  colorLight: "#F8F9FA",
  colorDark: "#343A40",
  colorWhite: "#FFF",
  colorBlack: "#000",
  itemSelectedBg: "#00266c",
  itemHoverColor: "#FFF",
};

export default colors;
